<template>
  <div class="container">
      <a-modal class="" :title="title[kind]" :visible="pollutionVisible"  @cancel="closeVisible"  width="70%" @ok="submit" >
         <a-form-model :model="pollutionList" ref="substanceListRef" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
                <a-row>
                    <a-col :span="12">
                        <a-form-model-item :label-col="{ span: 6 }" class="model_span_form" :wrapper-col="{ span: 18 }"
                            label="所属项目">
                            <span>{{category}}</span>
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-model-item :label-col="{ span: 6 }" class="model_span_form" :wrapper-col="{ span: 18 }"
                            label="所属分类"  prop="subcategory" :rules="{
								  required: true,
								  message: '请填写所属分类',
								  trigger: 'change',
								}">    
                                 <span v-if="kind == 2">{{ pollutionList.subcategory}}</span>
                                 <a-select allowClear placeholder="请选择污染物所属分类" v-model=" pollutionList.subcategoryId" @change="changeSubCategory" style="width: 100%;" 
                                 show-search :filter-option="filterOption" v-else :rules="{
								  required: true,
								  message: '请选择污染物所属分类',
								  trigger: 'change',
								}">
                                <a-select-option :value="item.categoryId" v-for="(item, index) in detailList" :key="index">
                                          {{ item.categoryName }}
                                </a-select-option>
                            </a-select>
                        </a-form-model-item>
                    </a-col>
                </a-row>
                  <a-row>
                    <a-col :span="12">
                        <a-form-model-item :label-col="{ span: 6 }" class="model_span_form" :wrapper-col="{ span: 18 }"
                            label="检测物质名称"  prop="factorName"  :rules="{
								  required: true,
								  message: '请填写检测物质名称',
								  trigger: 'change',
								}">
                            <span v-if="kind == 2">{{ pollutionList.factorName}}</span>
                              <a-input v-model="pollutionList.factorName" v-else></a-input>
                             
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-model-item :label-col="{ span: 6 }" class="model_span_form" :wrapper-col="{ span: 18 }"
                            label="单价（元）"  prop="price" :rules="{
								  required: true,
								  message: '请填写单价（元）',
								  trigger: 'change',
								}">    
                                 <span v-if="kind == 2">{{ pollutionList.price}}</span>
                                 <a-input v-model="pollutionList.price" oninput="value=value.replace(/[^\d\.]/g,'')" v-else></a-input>
                        </a-form-model-item>
                    </a-col>
                </a-row>
                 <a-row>
                    <a-col :span="12">
                        <a-form-model-item :label-col="{ span: 6 }" class="model_span_form" :wrapper-col="{ span: 18 }"
                            label="检测标准"  prop="standardInfo" :rules="{
								  required: true,
								  message: '请填写检测标准',
								  trigger: 'change',
								}">
                            <span v-if="kind == 2">{{ pollutionList.standardInfo}}</span>
                             <a-input v-model="pollutionList.standardInfo" v-else></a-input>
                        </a-form-model-item>
                    </a-col>
                </a-row>
                <a-row>
                    <a-col :span="12">
                        <a-form-model-item :label-col="{ span: 6 }" class="model_span_form" :wrapper-col="{ span: 18 }"
                            label="限制"  prop="limitRange"> 
                                <span v-if="kind == 2">{{ pollutionList.limitRange}}</span>             
                                 <a-input v-model="pollutionList.limitRange" v-else></a-input>
                        </a-form-model-item>
                    </a-col>
                </a-row>
            </a-form-model>
      </a-modal>



  </div>
</template>

<script>
import { editFactors_put, baseFactor_add } from '@/api/Industry'
import { getChargeList, getPollotantList} from '@/api/surrounding'
export default {
    props: [
        'pollutionVisible',
        'kind',
        'category',
        'pollutionList'
    ],
    data() {
        return {
            // pollutionVisible: false,
            title: [
                '新增污染物',
                '编辑污染物',
                '详情'],
            detailList: []
            // pollutionList: []
        }
    },
    created() {
        this.getDetail()

    },
    methods: {
         //查询下拉列表
         filterOption(input, option) {
				return (
					option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
				);
			},
              changeSubCategory(e) {
            this.detailList.forEach(item => {
                if (item.categoryId == e) {
                    this.pollutionList.subcategory = item.categoryName
                }
            })

        },
               // 查询污染物详细列表
        getDetail() {
              getChargeList({
                parentId: 1000
              }).then(res=> {
                 if(res.code == 200) {
                    this.detailList = res.data

                } else {
                    this.$message.error(res.msg)
                }
            
             })

        },
        closeVisible() {
            this.$refs.substanceListRef.resetFields()
            this.pollutionList = {}
            this.pollutionVisible = false
            this.$emit('changePollutionVisible', this.pollutionVisible)
        },
        submit() {
            Object.assign(this.pollutionList, {
                categoryId: 1000
            })
            if(this.kind == 0) {
                  this.$refs.substanceListRef.validate( valid=>{
                 if(valid){
                    baseFactor_add(this.pollutionList).then(res => {
                        if(res.code == 200) {
                            this.$message.success(res.msg)
                             this.pollutionList = {}
                             this.$emit('changePollutionList')
                         this.pollutionVisible = false
                         this.$emit('changePollutionVisible', this.pollutionVisible)

                        } else{
                            this.$message.console.error(res.msg);
                        }
                    })

                 }
            })

            }
             if(this.kind == 1) {
                  this.$refs.substanceListRef.validate( valid=>{
                 if(valid){
                     editFactors_put(this.pollutionList).then(res => {
                        if(res.code == 200) {
                            this.$message.success(res.msg)
                             this.pollutionList = {}
                             this.$emit('changePollutionList')
                         this.pollutionVisible = false
                         this.$emit('changePollutionVisible', this.pollutionVisible)

                        } else{
                            this.pollutionVisible = false
                            this.$emit('changePollutionVisible', this.pollutionVisible)
                            this.$message.error(res.msg);
                        }
                    })

                 }
            })
                
            }
            if(this.kind == 2) {
            this.pollutionList = {}
            this.pollutionVisible = false
            this.$emit('changePollutionVisible', this.pollutionVisible)
            }
          

        }
    }

}
</script>

<style>

</style>